export { default, detached } from './WonOpportunity';
